import axios from "axios";
import { ApiBriefReport, BriefSelection } from "./types";

const API_URL = process.env.REACT_APP_API_URL;

export const fetchBriefReport = async (projectId: string, selection: BriefSelection): Promise<ApiBriefReport> => {
  const params =
    selection.mode === "custom"
      ? { mode: "custom", start_date: selection.startDate, end_date: selection.endDate }
      : { mode: selection.mode, year: selection.year, month: selection.month };
  const res = await axios.get(`${API_URL}/project/${projectId}/monthly-brief-report`, {
    params,
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
  return res.data.data;
};
